import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AbstractFormComponent, DialogModal, Icon, TextDatePicker} from 'front-onceforall-core';
import {I18n, Translate} from 'react-redux-i18n';
import moment from 'moment-timezone';
import * as snackbarsActions from '../../actions/snackbars';
import interventionService from '../../services/intervention/InterventionService';
import {captureError} from '../../utils/log';

export class InterventionDateModalForm extends AbstractFormComponent {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state
    };
  }

  getFormData() {
    return {
      date: this.props.intervention.interventionDate ? moment(this.props.intervention.interventionDate) : null
    };
  }

  getFormValidators() {
    return {
      date: this.dateValidator.bind(this)
    };
  }

  dateValidator(value) {
    if (value && moment(value).startOf('day').isSameOrBefore(this.props.intervention.project.openingDate)) {
      return 'intervention.dateForm.error';
    }

    return null;
  }

  handleSubmitCallback() {
    const selectedDate = this.state.formData.date ? this.state.formData.date.startOf('day').toISOString() : null;

    interventionService.setInterventionDate(this.props.intervention.interventionId, selectedDate)
      .then(() => {
        this.props.actions.addSuccess(<Translate value="intervention.dateForm.saveSuccess"/>);
      })
      .catch(error => {
        this.props.actions.addError(<Translate value="error.generic"/>);
        captureError('Error while saving specific intervention date', error);
      })
      .finally(() => {
        this.props.onClose(true);
      });
  }

  render() {
    return (
      <DialogModal
        isOpen={this.props.isOpen}
        onClose={() => this.props.onClose(false)}
        title={<Translate value="intervention.dateForm.title"/>}
      >
        <form onSubmit={this.handleSubmit}>
          <div
            className="warning flex-container mb-4"
            style={{marginTop: -8}}
          >
            <div className="flex-shrink-0">
              <Icon
                icon="warning"
                size={18}
              />
            </div>
            <div>
              <Translate
                value="intervention.dateForm.error"
                tag="strong"
              />:&nbsp;
              <strong>{I18n.l(this.props.intervention.project.openingDate, {dateFormat: 'datetime.shortDate'})}</strong>
            </div>
          </div>
          <TextDatePicker
            name="date"
            label={this.getFieldLabel('intervention.dateForm.fieldLabel', false)}
            value={this.state.formData.date}
            onChange={this.handleChange('date')}
            placeholder={I18n.t('datetime.shortDate')}
            helperText={this.helperText('date')}
            error={this.isOnError('date')}
            minDate={moment(this.props.intervention.project.openingDate).add(1, 'd')}
          />
          <div className="flex-container space-between mt-4">
            <button
              type="button"
              className="small secondary flex-container"
              onClick={() => this.props.onClose(false)}
            >
              <Icon icon="go-back"/>
              <Translate value="action.cancel"/>
            </button>
            <button
              className="small primary flex-container"
              type="submit"
              disabled={this.state.submitting}
            >
              <Icon icon={this.state.submitting ? 'loader' : 'check'}/>
              <Translate value="action.confirm"/>
            </button>
          </div>
        </form>
      </DialogModal>
    );
  }
}

InterventionDateModalForm.propTypes = {
  intervention: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  actions: PropTypes.object.isRequired
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({...snackbarsActions}, dispatch)
  };
}

export default connect(null, mapDispatchToProps)(InterventionDateModalForm);
